import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/MedicalInsurance/keyPointVerticalNumericData.json';

import MedicalInsuranceSeoDetailModuleComponent from '../HomePage/SeoDetailModule/MedicalInsuranceSeoDetailModuleComponent';
import MedicalInsuranceSeoDetailModuleMobileComponent from '../HomePage/SeoDetailModule/MedicalInsuranceSeoDetailModuleMobileComponent';
import seoDetailModuleData from '../../json/components/HomePages/MedicalInsurance/seoDetailModuleData.json';

import SeoSnakeGuideComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideComponent';
import SeoSnakeGuideMobileComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideMobileComponent';
import snakeGuideData from '../../json/components/HomePages/MedicalInsurance/snakeGuideData.json';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/MedicalInsurance/partnerBrandsData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/MedicalInsurance/fourBlogCardsData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/MedicalInsurance/customerReviewsData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/MedicalInsurance/accordionFAQData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsDataAll from '../../json/components/HomePages/MedicalInsurance/scrollingCardsAllData.json';

import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

function MedicalInsurancePage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/medical-insurance-quotes/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestMedicalInsuranceQuotes_CrossSell"
        fallbackKey="latestMedicalInsuranceQuotes"
        navigateTo="/medical-insurance-quotes/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SeoSnakeGuideComponent data={snakeGuideData} />
        ) : (
          <SeoSnakeGuideMobileComponent data={snakeGuideData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Medical costs adding up? We can help.'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Medical costs adding up? We can help.'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <MedicalInsuranceSeoDetailModuleComponent
            data={seoDetailModuleData}
          />
        ) : (
          <MedicalInsuranceSeoDetailModuleMobileComponent
            data={seoDetailModuleData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Don’t let insurance jargon make you sick'}
            buttonColor={'green'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Don’t let insurance jargon make you sick'}
            color={'blue'}
            buttonColor={'green'}
            buttonText={'Ask Hippo'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent data={fourBlogCardsData} tag="health" />
        ) : (
          <FourBlogCardsMobileComponent data={fourBlogCardsData} tag="health" />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsDataAll} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsDataAll} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default MedicalInsurancePage;
